/**
 * @deprecated will be removed or significantly changed in future versions
 */
export interface IBorderRadius {
    "border-radius-none": string;
    "border-radius-4x-small": string;
    "border-radius-3x-small": string;
    "border-radius-xx-small": string;
    "border-radius-x-small": string;
    "border-radius-small": string;
    "border-radius-regular": string;
    "border-radius-medium": string;
    "border-radius-large": string;
    "border-radius-x-large": string;
    "border-radius-xx-large": string;
    "border-radius-3x-large": string;
    "border-radius-4x-large": string;
    "border-radius-full": string;
}

/**
 * @deprecated will be removed or significantly changed in future versions
 */
export interface IBorderWidth {
    "border-width-regular": string;
    "border-width-medium": string;
    "border-width-large": string;
    "border-width-x-large": string;
}
